import type { Organization } from "../../../api/adminOrganizations";
import type { AdminUser } from "../../../api/adminUsers";
import { roleNames } from "../../../model/organizationRoles";

const UNKNOWN_ORGANIZATION = "?";

/** "Organization (Role, Role)" for each organization the user belongs to, sorted and comma-separated. */
export function membershipSummary(user: AdminUser, organizations: Organization[]): string {
  return user.memberships
    .map((m) => `${organizations.find((o) => o.id === m.organizationId)?.name ?? UNKNOWN_ORGANIZATION} (${roleNames(m.roles)})`)
    .sort()
    .join(", ");
}
